import { ICallableRequestBuilder } from "../requestBuilder/types";
import config from "@shared/config/client";
import { ViewCount } from "./type";

const getNftViewsCount =
  (request: ICallableRequestBuilder<number>) => (nftId: string) => {
    const url = `${config.apiUrl}/views/${nftId}`;
    return request.call(url);
  };

const getMostViewedNfts =
  (request: ICallableRequestBuilder<ViewCount[]>) => () => {
    const url = `${config.apiUrl}/views/nft/most-viewed`;
    return request.call(url);
  };

const request = {
  getNftViewsCount,
  getMostViewedNfts,
};

export default request;
